/*
 * @Author: www
 * @Date: 2019-03-24 14:55:39
 * @Last Modified by: chenxiaoxong
 * @Last Modified time: 2022-03-29 09:22:54
 */
import { cloneDeep } from 'lodash';
import { getPermissionList } from '@/api/permission';

export const ADD_PERMISSION = 'ADD_PERMISSION';
export const RESET = 'RESET';

const initState = {
  permissions: [], // 用户权限
  getPermissionMenus: 'padding',
};

const mutations = {
  [ADD_PERMISSION](state, payload) {
    state.permissions = payload;
    state.getPermissionMenus = 'getPermissionMenus';
  },
  [RESET](state) {
    Object.assign(state, cloneDeep(initState));
  },
};

const actions = {
  async fetchPermission({ commit }) {
    const permissions = (await getPermissionList()) || [];
    // 格式化菜单数据再提交
    commit(ADD_PERMISSION, [
      ...permissions.map((menu) => ({
        id: menu.id,
        name: menu.name,
        path: menu.path,
        icon: menu.icon,
        buttons: menu.buttons.map(({ id, type, name }) => ({
          id,
          type: +type,
          name,
        })),
        children: menu.child.map((subMenu) => ({
          id: subMenu.id,
          name: subMenu.name,
          path: subMenu.path,
          buttons: subMenu.buttons.map(({ id, type, name }) => ({
            id,
            type: +type,
            name,
          })),
        })),
      })),
    ]);
  },
};

const getters = {
  menus(state) {
    return state.permissions;
  },
  getPermissionMenus(state) {
    return state.getPermissionMenus;
  },
  /**
   * 获取菜单对应页面按钮操作权限
   * type: 按钮类型，对应后台配置参数
   * route: 为视图页config.js配置文件中的对象, 生成路由时已注入到页面
   */
  hasPermission: (state) => (type, route) => {
    // 多次触发减少后续判断
    if (!state.permissions.length) {
      return false;
    }
    const mainMenu = state.permissions.find(({ path }) => path === route.path);
    // 无权限访问页面: 1.动态更新用户权限后刷新页面
    if (!mainMenu) {
      return false;
    }
    if (!route.children.path) {
      // 一级菜单按钮权限
      return mainMenu.buttons.map((item) => item.type).includes(type);
    } else {
      // 二级菜单按钮权限
      const subMenu = mainMenu.children.find(({ path }) => path === route.children.path);
      if (!subMenu) {
        return false;
      }
      return subMenu.buttons.map((item) => item.type).includes(type);
    }
  },
  // 是否有主菜单权限（index）
  hasMainMenu: (state) => (route) => {
    // 多次触发减少后续判断
    if (!state.permissions.length) {
      return false;
    }
    const mainMenu = state.permissions.find(({ path }) => path === route.path);
    // 无权限访问页面: 1.动态更新用户权限后刷新页面
    if (!mainMenu) {
      return false;
    } else {
      return true;
    }
  },
};

export default {
  name: 'permission',
  namespaced: true,
  state: cloneDeep(initState),
  mutations,
  actions,
  getters,
};
